import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import VXETable from "vxe-table";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/index.css";
import "vxe-table/lib/style.css";
import { install } from "feiwin_npm";

import "./plugin/vant";

import { looktype } from "./utils/mixins";
Vue.mixin(looktype);

Vue.use(ElementUI)
  .use(VXETable)
  .use(install, {
    NODE_ENV: process.env.NODE_ENV,
    VUE_APP_API_URL: VUE_APP_API_URL,
  });

Vue.config.productionTip = false;

// 引入全局过滤器函数
import * as filters from "@/filters/index.js";
// 循环注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

import Axios from "./server/ajax.js";
import utils from "./utils/index.js";
Vue.prototype.$axios = Axios;
Vue.prototype.$utils = utils;

Vue.directive("btn-throttling", {
  inserted: function(el, binding) {
    el.addEventListener("click", () => {
      // 判断按钮是否可点击
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, binding.value || 3000); //默认3秒节流时间
      }
    });
  },
});
function init() {
  return new Promise(async resolve => {
    Axios.postJSON("/base/company_permission/valid/map", {
      company_id: 0,
    }).then(res => {
      resolve();
      if (res.set.set_map == "baidu") {
        let MAP_BAIDU = VUE_APP_MAP_BAIDU || [];
        const AK = MAP_BAIDU[Math.floor(Math.random() * MAP_BAIDU.length)];
        const BMap_URL =
          "https://api.map.baidu.com/api?type=webgl&v=1.0&ak=" +
          AK +
          "&s=1&callback=onBMapCallback";

        window.onBMapCallback = function() {
          console.log("百度地图脚本初始化成功...");
          // eslint-disable-next-line no-undef
          resolve(BMapGL);
        };
        console.log("开始加载了...");
        // 插入script脚本
        let scriptNode = document.createElement("script");
        scriptNode.setAttribute("type", "text/javascript");
        scriptNode.setAttribute("src", BMap_URL);
        document.body.appendChild(scriptNode);
      } else {
        let AK = VUE_APP_MAP_KEY || "";
        const BMap_URL = "https://api.tianditu.gov.cn/api?v=4.0&tk=" + AK;
        if (window.T) return resolve(window.T);
        const script = document.createElement("script");
        script.src = BMap_URL;
        script.onload = () => resolve(window.T);
        document.head.appendChild(script);
      }
    });
  });
}

init().then(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount("#app");
});
